module.exports = ".modal-body{\r\n    -webkit-box-shadow: 0 11px 15px -7px rgba(0,0,0,.2), 0 24px 38px 3px rgba(0,0,0,.14), 0 9px 46px 8px rgba(0,0,0,.12);\r\n            box-shadow: 0 11px 15px -7px rgba(0,0,0,.2), 0 24px 38px 3px rgba(0,0,0,.14), 0 9px 46px 8px rgba(0,0,0,.12);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/backend/modules/alert/alert.component.css
// module id = ./src/app/backend/modules/alert/alert.component.css
// module chunks = common